// Book Preview Modal Functionality
document.addEventListener('DOMContentLoaded', function() {
  var triggerButton = document.querySelector('[data-book-preview-trigger]');
  var modal = document.querySelector('[data-book-preview-modal]');
  var closeButtons = document.querySelectorAll('[data-book-preview-close]');
  var iframeContainer = document.querySelector('[data-book-preview-iframe]');
  
  if (!triggerButton || !modal) {
    console.log('Book preview elements not found');
    return;
  }
  
  console.log('Book preview script loaded successfully');
  
  // Open modal functie
  triggerButton.addEventListener('click', function(e) {
    e.preventDefault();
    console.log('Preview button clicked');
    
    // Toon de modal
    modal.style.display = 'block';
    modal.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    
    // Laad de iframe
    if (iframeContainer && !iframeContainer.querySelector('iframe')) {
      console.log('Loading iframe content...');
      // Haal de metafield waarde op uit het data attribuut
      var metafieldContent = window.bookPreviewData || '';
      if (metafieldContent) {
        iframeContainer.innerHTML = metafieldContent;
      }
    }
  });
  
  // Sluit modal functie
  function closeModal() {
    console.log('Closing modal');
    modal.style.display = 'none';
    modal.classList.remove('is-active');
   document.body.style.overflow = '';
  }
  
  // Event listeners voor sluiten
  closeButtons.forEach(function(button) {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      closeModal();
    });
  });
  
  // Sluit met ESC toets
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.classList.contains('is-active')) {
      closeModal();
    }
  });
});